<template>
  <div class="lang-switch" role="group" :aria-label="$t('common.language.switchTo')">
    <router-link
      v-for="l in choices"
      :key="l"
      :to="target(l)"
      :lang="l"
      :hreflang="l"
      :aria-label="$t('common.language.' + l)"
      :title="$t('common.language.' + l)"
      :aria-current="current === l ? 'true' : undefined"
      :class="{ active: current === l }"
      @click="remember(l)"
    >
      {{ l.toUpperCase() }}
    </router-link>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { SUPPORTED, setLocale } from '@/i18n';

export default {
  name: 'LanguageSwitcher',
  setup() {
    const route = useRoute();
    const current = computed(() => route.params.lang);
    // same page, other language
    const target = (l) => ({ name: route.name || 'LandingPage', params: { ...route.params, lang: l }, query: route.query, hash: route.hash });
    const remember = (l) => setLocale(l);
    return { choices: SUPPORTED, current, target, remember };
  },
};
</script>

<style scoped>
.lang-switch {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: var(--radius-pill);
  background: var(--color-subtle);
}
.lang-switch a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  min-width: 44px;
  min-height: 36px;
  border: none;
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--color-secondary);
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.lang-switch a.active {
  background: var(--color-primary);
  color: var(--color-on-primary);
}
:global(body.dark-mode) .lang-switch a:not(.active) {
  color: var(--color-text-light);
}
</style>
